// frontend/src/components/layout/FloatingToolStrip.jsx
import React from "react"
import "./FloatingToolStrip.css"

const TOOLS = [
  {
    id:    "notif",
    label: "Notifications",
    badge: 4,
    badgeColor: "#D85A30",
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M8 2a5 5 0 00-5 5v3l-1 2h12l-1-2V7a5 5 0 00-5-5z"
              stroke="currentColor" strokeWidth="1.2"/>
        <path d="M6.5 13.5a1.5 1.5 0 003 0"
              stroke="currentColor" strokeWidth="1.2"/>
      </svg>
    ),
  },
  {
    id:    "chat",
    label: "Internal Chat",
    badge: 2,
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M1 3h14v8a1 1 0 01-1 1H4l-3 2V4a1 1 0 011-1z"
              stroke="currentColor" strokeWidth="1.2"/>
      </svg>
    ),
  },
  {
    id:    "wa",
    label: "WhatsApp",
    badge: 0,
    iconColor: "#1D9E75",
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="6" stroke="#1D9E75" strokeWidth="1.2"/>
        <path d="M5.5 6c.5 1 1.3 2 2.5 2.5l.8-.8.9 1.8-.8.8a8.1 8.1 0 01-3.4-5z"
              stroke="#1D9E75" strokeWidth="1.1"/>
      </svg>
    ),
  },
  {
    id:    "todo",
    label: "My Tasks",
    badge: 3,
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M3 4h10M3 8h7M3 12h5"
              stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      </svg>
    ),
  },
  // ── Drop I — DMS preview tab ──────────────────────────────
  {
    id:    "dms",
    label: "DMS Preview",
    badge: 0,
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        {/* Document outline with folded corner */}
        <path d="M3 1.5h7l3 3v10a0.5 0.5 0 01-0.5 0.5h-9.5a0.5 0.5 0 01-0.5-0.5v-12.5a0.5 0.5 0 01.5-.5z"
              stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
        <path d="M10 1.5v3h3"
              stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
        {/* Document content lines */}
        <path d="M5 7.5h6M5 9.5h6M5 11.5h4"
              stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id:    "calc",
    label: "Calculator",
    badge: 0,
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <rect x="2" y="1" width="12" height="14" rx="1"
              stroke="currentColor" strokeWidth="1.2"/>
        <path d="M5 5h6M5 8h2M9 8h2M5 11h2M9 11h2"
              stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id:    "tools",
    label: "Integrations",
    badge: 0,
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.2"/>
        <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.1 3.1l1.4 1.4M11.5 11.5l1.4 1.4M12.9 3.1l-1.4 1.4M4.5 11.5l-1.4 1.4"
              stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id:    "help",
    label: "Help & Docs",
    badge: 0,
    icon: (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.2"/>
        <path d="M6.5 6a1.5 1.5 0 113 0c0 1-1.5 1.5-1.5 2.5M8 12v.5"
              stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
  },
]

const FloatingToolStrip = ({ activePanel, onTogglePanel }) => (
  <div className="ft-strip">
    <div className="ft-strip-inner">
      {TOOLS.map(t => (
        <button
          key={t.id}
          className={`ft-btn ${activePanel === t.id ? "active" : ""}`}
          onClick={() => onTogglePanel(t.id)}
          title={t.label}
        >
          {t.icon}
          {t.badge > 0 && (
            <span
              className="ft-badge"
              style={t.badgeColor ? { background: t.badgeColor } : undefined}
            >
              {t.badge}
            </span>
          )}
          <span className="ft-tooltip">{t.label}</span>
        </button>
      ))}
    </div>
  </div>
)

export default FloatingToolStrip
